import React, { CSSProperties, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { AppActions } from '../app';
import { DEFAULT_BANNER_CAROUSEL } from '../base/constants';
import styles from './BannerCarousel.module.scss';
import BannerCarouselSlide from './BannerCarouselSlide';
import CarouselController from './CarouselController';
import useCarousel from './useCarousel';

export const BannerCarouselContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { current, length, pauseSlider, unpauseSlider } = useCarousel();
  // define css variables needed for animation
  const carouselStyles = useMemo(() => {
    return {
      '--num-slides': length,
      '--current-slide': current,
      '--height': length > 0 ? '64px' : '0',
    };
  }, [current, length]);
  const dispatch = useDispatch();
  useEffect(() => {
    // notify store that banner is shown
    dispatch(AppActions.appBanner(length > 0));
  }, [dispatch, length]);

  return (
    <div
      className={styles.BannerCarousel}
      style={carouselStyles as CSSProperties}
      onMouseEnter={pauseSlider}
      onMouseLeave={unpauseSlider}>
      <div className={styles.BannerCarouselContainer}>
        <div className={styles.BannerCarouselContent}>{children}</div>
      </div>
    </div>
  );
};

export const BannerCarousel: React.FC<React.PropsWithChildren> = ({ children }) => {
  const slides = React.Children.toArray(children).map((child, index) => (
    <BannerCarouselSlide key={index}>{child}</BannerCarouselSlide>
  ));
  const bannerCarouselConfig = DEFAULT_BANNER_CAROUSEL;
  const isCarouselEnabled = bannerCarouselConfig?.enabled;
  const carouselTimeoutConfig = bannerCarouselConfig?.timeout;
  const animationTime = isCarouselEnabled ? carouselTimeoutConfig : 0;
  return (
    <CarouselController auto={true} animationTime={animationTime}>
      <BannerCarouselContainer>{slides}</BannerCarouselContainer>
    </CarouselController>
  );
};

export default BannerCarousel;
